<script>
	//	the accessible twin of the chart: every value, no colour needed
	export let header = [];
	export let rows = [];
	export let caption = "";
</script>

<!-- svelte-ignore a11y_no_noninteractive_tabindex (The table scroll region must be keyboard reachable.) -->
<div class="tableWrap" tabindex="0" role="region" aria-label={caption ? `Date: ${caption}` : "Datele graficului"}>
	<table>
		{#if caption}<caption>{caption}</caption>{/if}
		<thead>
			<tr>
				{#each header as h, i}
					<th scope="col" class:num={i > 0}>{h}</th>
				{/each}
			</tr>
		</thead>
		<tbody>
			{#each rows as r}
				<tr>
					{#each r as c, i}
						{#if i === 0}
							<th scope="row">{c}</th>
						{:else}
							<td class="num">{c}</td>
						{/if}
					{/each}
				</tr>
			{/each}
		</tbody>
	</table>
</div>

<style>
	.tableWrap {
		overflow-x: auto;
		max-height: 420px;
		overflow-y: auto;
		margin-top: 8px;
		border: 1px solid var(--_grid);
		border-radius: 4px;
	}

	.tableWrap:focus-visible { outline: 2px solid var(--_accent); outline-offset: 3px; }
	tbody tr:nth-child(even) { background: var(--_wash); }
	tbody th { min-width: 7rem; }

	table {
		width: 100%;
		border-collapse: collapse;
		font-size: 14px;
		line-height: 1.4;
		color: var(--_ink);
		font-family: var(--_font);
	}

	caption {
		position: absolute;
		width: 1px;
		height: 1px;
		overflow: hidden;
		clip: rect(0 0 0 0);
	}

	th,
	td {
		padding: 10px 12px;
		text-align: left;
		border-top: 1px solid var(--_grid);
		font-weight: 400;
	}

	thead th {
		font-family: var(--_font);
		border-top: 0;
		font-weight: 600;
		color: var(--_ink-muted);
		font-size: 13px;
		text-transform: none;
		letter-spacing: 0;
		position: sticky;
		top: 0;
		background: var(--_surface);
	}

	.num {
		text-align: right;
		font-variant-numeric: tabular-nums;
		font-family: var(--_num-font);
	}
</style>
